import React, { useEffect, useMemo } from 'react';
import SubpageTopBar from './SubpageTopBar';
import AppLegalDocumentLayout from '../components/AppLegalDocumentLayout';
import { getAppConfig, isKnownAppSlug } from '../config/apps';
import { getPrivacyPageContent } from '../content/privacy';
import NotFoundPage from './NotFoundPage';

function AppPrivacyPolicyPage({ match }) {
  const { appSlug } = match.params;
  const validSlug = isKnownAppSlug(appSlug);
  const app = validSlug ? getAppConfig(appSlug) : null;

  const privacyContent = useMemo(
    () => (validSlug ? getPrivacyPageContent(appSlug) : null),
    [validSlug, appSlug]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [appSlug]);

  useEffect(() => {
    if (!validSlug || !app || !privacyContent) {
      return undefined;
    }
    document.title = `Privacy Policy – ${app.contact.brandName}`;
    return () => {
      document.title = 'East IT';
    };
  }, [validSlug, app, privacyContent]);

  if (!validSlug || !app || !privacyContent) {
    return <NotFoundPage />;
  }

  return (
    <div className="App">
      <SubpageTopBar />
      <AppLegalDocumentLayout
        contact={app.contact}
        docTitle={privacyContent.pageTitle}
        subtitle={privacyContent.subtitle}
        updatedBadge={privacyContent.updatedBadge}
        tocTitle={privacyContent.tocTitle}
        tocItems={privacyContent.tocItems}
        summary={privacyContent.summary}
        sections={privacyContent.sections}
      />
    </div>
  );
}

export default AppPrivacyPolicyPage;
